import {
  MdDashboard,
  MdBuild,
  MdPeople,
  MdOutlineMessage,
  MdCategory,
  MdAutorenew,
  MdTag,
  MdOutlineInsertChart,
  MdBusiness,
  MdDomain,
  MdMoreHoriz,
} from "react-icons/md";

/** Todas las rutas del panel (sidebar escritorio + hoja "Más" en móvil) */
export const NAV_ITEMS = [
  { label: "Dashboard", shortLabel: "Inicio", icon: MdDashboard, route: "/Home" },
  { label: "Técnicos Independientes", shortLabel: "Técnicos", icon: MdBuild, route: "/Control-Tecnico" },
  { label: "Técnicos Partner", shortLabel: "Partners", icon: MdBusiness, route: "/Tecnicos-Partner" },
  { label: "Empresas Partner", shortLabel: "Empresas", icon: MdDomain, route: "/Empresas-Partner" },
  { label: "Clientes", shortLabel: "Clientes", icon: MdPeople, route: "/Control-cliente" },
  { label: "Publicidades", shortLabel: "Avisos", icon: MdOutlineMessage, route: "/Publicidad" },
  { label: "Suscripciones", shortLabel: "Planes", icon: MdAutorenew, route: "/Suscripciones" },
  { label: "Usuarios & Roles", shortLabel: "Usuarios", icon: MdCategory, route: "/Categorias" },
  { label: "Categorías", shortLabel: "Categorías", icon: MdTag, route: "/Categoria" },
  { label: "Actividad", shortLabel: "Actividad", icon: MdPeople, route: "/Actividades" },
  { label: "Reportes", shortLabel: "Reportes", icon: MdOutlineInsertChart, route: "/Reportes" },
];

/** Rutas visibles en la tab bar inferior (móvil / tablet) */
export const TAB_BAR_ROUTES = ["/Home", "/Control-Tecnico", "/Control-cliente", "/Publicidad"];

export const TAB_BAR_ITEMS = [
  NAV_ITEMS.find((i) => i.route === "/Home"),
  NAV_ITEMS.find((i) => i.route === "/Control-Tecnico"),
  NAV_ITEMS.find((i) => i.route === "/Control-cliente"),
  NAV_ITEMS.find((i) => i.route === "/Publicidad"),
  { label: "Más", shortLabel: "Más", icon: MdMoreHoriz, route: null, isMore: true },
];

export const MORE_MENU_ITEMS = NAV_ITEMS.filter((item) => !TAB_BAR_ROUTES.includes(item.route));

export const LOGO_URL = "https://cdn-icons-png.flaticon.com/512/942/942748.png";

export const isRouteActive = (pathname, route) => pathname === route;

export const isMoreRouteActive = (pathname) =>
  MORE_MENU_ITEMS.some((item) => item.route === pathname);
